<template>
  <div class="charts-container">
    <div class="page-title">Grade {{ parentData.formType | applicationType }} Application</div>
    <el-row type="flex" :gutter="20">
      <el-col :span="12"><pie-chart :chart-data="newData" /></el-col>
      <el-col :span="12">    
          <div style="margin: 30px 0;" class="row-container">
              <div v-for="(item, index) in parentData.list" :key="index">
                <div style="margin: 10px 0;" :class="`chart-item-box${index} chart-item-container`">
                  <el-row type="flex" align="center" :gutter="10">
                    <el-col :span="4">
                      <span
                        v-if="item.itemStyle"
                        class="chart-item-legend"
                        :style="{ backgroundColor: item.itemStyle.color }"
                      ></span>
                    </el-col>
                    <el-col :span="16">
                      <span>{{ item.stage | applicationStage }}</span>
                    </el-col>
                    <el-col :span="4">
                      <span>{{ item.count }}</span>
                    </el-col>
                  </el-row>
                </div>
              </div>
          </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { applicationStage } from "@/filters/index";
import pieChart from "./pieChart";
export default {
  components: { pieChart },
  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  computed:{
    newData(){
      return this.parentData.list.map((v)=>{
        v.value= v.count,
        v.name= applicationStage(v.stage)
        return v
      })
    }
  },
  data() {
    return {
      
    };
  },
};
</script>

<style lang="scss" scoped>
.page-title{
  text-align: center;
  margin-bottom: 80px;
}
.charts-container {
  padding: 20px;
  border: 1px solid #ccc;
}
.category-container {
  padding-left: 30px;
  padding-right: 30px;
  .category-box {
    font-size: 28px;
    padding: 15px;
    color: white;
    font-weight: bold;
    border-radius: 10px;
    background-image: linear-gradient(to right, #ec8c69 0%, #ed6ea0 100%);
  }
  .chart-item-box0 {
    background-image: linear-gradient(-225deg, #58c5d9 0%, #b8f2e6 100%);
    margin-right: 10px;
  }
  .chart-item-box1 {
    margin-right: 10px;
    background-image: linear-gradient(-225deg, #f08685 0%, #f2d7d7 100%);
  }
  .chart-item-box2 {
    margin-right: 10px;
    background-image: linear-gradient(-225deg, #94d9cb 0%, #d7eac2 100%);
  }
  .chart-item-box3 {
    background-image: linear-gradient(-225deg, #fcbc8d 0%, #fee9d9 100%);
  }
  .chart-item-container {
    margin-bottom: 20px;
    border-radius: 15px;
    height: 200px;
    h3 {
      padding-top: 30px;
      padding-left: 30px;
      font-size: 40px;
      margin-bottom: 0;
    }
    p {
      margin-top: 5px;
      padding-left: 30px;
      font-size: 20px;
      font-weight: bold;
    }
  }
}
.chart-item-legend {
  //长方形
  display: inline-block;
  width: 100%;
  height: 10px;
}
.row-container{
  display: flex;
  flex-direction: column;
}
</style>

